import { type FC } from "react";
import { Button } from "@root/shared/components/Button";
import { useFormContext } from "react-hook-form";
import * as styles from "./styles.css";

type Props = {
  handleClose: () => void;
};

export const FooterButtons: FC<Props> = ({ handleClose }) => {
  const {
    formState: { isSubmitting },
  } = useFormContext();

  return (
    <div className={styles.buttonContainer}>
      <Button theme="tertiary" onClick={handleClose} className={styles.cancelButton}>
        キャンセル
      </Button>
      <Button
        theme="primary"
        form="form"
        type="submit"
        className={styles.submitButton}
        disabled={isSubmitting}
      >
        期限を延長する
      </Button>
    </div>
  );
};
